module.exports = __webpack_public_path__ + "img/djup.4c3f8a4b.svg";